import { Component, HostBinding, Input } from '@angular/core'

import { BgColorDirective } from '../../directives/ui-tools/bg-color.directive'
import { TextColorDirective } from '../../directives/ui-tools/text-color.directive'

@Component({
    selector: 'sf-info-box',
    imports: [],
    templateUrl: './info-box.component.html',
    styleUrls: ['./info-box.component.scss'],
    hostDirectives: [
        { directive: BgColorDirective, inputs: ['color'] },
        { directive: TextColorDirective, inputs: ['color: text-color'] },
    ]
})
export class InfoBoxComponent {
    @HostBinding('class') class = 'info-box d-block'

    @Input() header!: string
}
